import { motion } from 'framer-motion';

export default function Stamp({ className = '' }) {
  return (
    <motion.a
      href="https://mindi.tv"
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-block no-underline ${className}`}
      style={{ rotate: '-2deg' }}
      whileHover={{ rotate: '-1deg', scale: 1.04 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
    >
      <div
        className="px-5 py-2 font-display text-white tracking-wider text-center"
        style={{
          backgroundColor: '#E8721C',
          boxShadow: '2px 4px 12px rgba(0,0,0,0.35)',
        }}
      >
        <div
          className="px-3 py-1"
          style={{
            border: '2px dashed rgba(255,255,255,0.5)',
          }}
        >
          POWERED BY MINDI.TV
        </div>
      </div>
    </motion.a>
  );
}
